import React from 'react';
import './property.css';
import location from './../../../assets/locationicon.svg'

import Button1 from './button';
import Status from './propstatus';

const Property = (props) => {
    return ( <>
    <div className="propertyCard">
        <Status status={props.statustype} text={props.statustxt} />
        <img className='propertyimg' src={props.img} alt="" />
        <div className="propertyDeets">
            <div className="location">
                <img src={location} alt="" />
                {props.location}
            </div>
            <h3 className='h3_2'>
                {props.title}
            </h3>
            <div className="propertyCTA">
                <div>
            <h6>Starting From</h6>
                <h5>
                    {props.price}
                </h5>
                <span>
                    EGP
                </span>
                </div>
                <Button1 style2="secondarySmall secondarySmall2" cta="Explore" />
            </div>
        </div>
    </div>
    </> );
}
 
export default Property;